import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { getSmsHistory } from '../requests/notification.request';

export const useSmsHistoryQuery = (clientId: string, enabled = true) => {
  return useQuery({
    queryKey: ['sms-history', clientId],
    queryFn: async () => await getSmsHistory(clientId),
    enabled: enabled && !!clientId,
    onError: () => {
      toast.error("Couldn't fetch SMS history", { id: 'sms-history-error' });
    }
  });
};
